
import 'bootstrap';
import { Tooltip } from 'bootstrap';

import '../../components/preloader/preloader';

import '../../font-service/font-service';

import '../../components/navi-bootstrap-offcanvas/navi-bootstrap-offcanvas';
import '../../components/navi-desktop-bootstrap/navi-desktop-bootstrap';
import '../../components/fullScreenStarter/fullScreenStarter';
import '../../components/purpose-counter/purpose-counter';
import '../../components/home-gallery/home-gallery';
import '../../components/dsgvo-api-maps/dsgvo-api-maps';
import '../../components/smooth-scrolling/smooth-scrolling.js';

import lazySizes from 'lazysizes';

import './scss/front-page.scss';

// Tooltips Only on non Touch devices 

function isTouchDevice() {
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}
if (isTouchDevice() === false) {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl)
    })
}




//Toggle btns

const toggleBtns = [...document.querySelectorAll(".more-icon")]
toggleBtns.forEach((btn) => {
    $(btn).on('click', (e) => {
        const targetSelector = e.currentTarget.dataset.toggletarget;
        $(targetSelector).slideToggle("slow");
    });
})

// Nav Controll

$('.hamburger-indy.white').css({ opacity: 0 })

const showWhiteNav = () => {
    $('.hamburger-indy.white').css({ opacity: 1 })
    $('.hamburger-indy.color').css({ opacity: 0 })
}

const hideWhiteNav = () => {
    $('.hamburger-indy.white').css({ opacity: 0 })
    $('.hamburger-indy.color').css({ opacity: 1 })
}



const options = {
    rootMargin: '0px',

}

const observer = new IntersectionObserver((entries, observer) => {

    entries.forEach(entry => {
        if (entry.isIntersecting === true) {
            showWhiteNav()
        } else {
            hideWhiteNav()
        }
    })

}, options);

const target = document.querySelector('#starter-fs')

observer.observe(target)
